import { useStore } from "vuex"
import { computed, onMounted } from 'vue'

export default {
    name: "ThemeCard",
    props: {
        content: {
            type: Object,
            default: {},
        },
        layoutA: {
            type: Boolean,
            default: false
        },
    },
    setup(props) {
        const store = useStore()

        const statistics = computed(() => store.state.forum.theme_statistics[props.content.themeId])
        const groupsCount = computed(() => statistics.value?.groupsCount)
        
        onMounted(() => {

            if (props.content.themeId) {
                store.dispatch("forum/getThemeStatistics", {
                    themeId: props.content.themeId
                })
            }
        })

        const getLabel = (labelKey) =>
            store.getters["labels/getLabel"]({
                labelCollection: "ThemeCard",
                labelKey,
            })

        return {
            groupsCount,
            getLabel
        }
    }
}